import React from "react";

const ALERT_STYLES = {
  success: {
    backgroundColor: "#10882cff",
    color: "#ffffffff"
  },
  error: {
    backgroundColor: "#b6121fff",
    color: "#ffffffff"
  },
  warning: {
    backgroundColor: "#e4af02ff",
    color: "#ffffffff"
  },
};

const AlertMessage = ({ type = "success", message, onClose }) => {
  if (!message) return null;

  return (
    <div
      style={{
        padding: "12px 16px",
        borderRadius: "6px",
        margin: "10px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        ...ALERT_STYLES[type],
      }}
    >
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
            color: ALERT_STYLES[type].color,
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AlertMessage;
